var _defs, _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _path5, _polyline, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4e7e8ba-03ea-43b6-8bce-0c249c96230c",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a672974d-716e-48ff-a464-489c56832120,.f630b36d-1522-47b6-bd06-739978c3d603{fill:none;}.e31261bd-5151-4231-902b-7cf937ddce1f,.f630b36d-1522-47b6-bd06-739978c3d603{stroke:#8e8e8e;}.a672974d-716e-48ff-a464-489c56832120,.e31261bd-5151-4231-902b-7cf937ddce1f,.f38b0bb9-7a65-4de5-97d2-b2002db1b20b,.f630b36d-1522-47b6-bd06-739978c3d603{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.a0eac549-1715-4447-b635-0020002fa102,.e31261bd-5151-4231-902b-7cf937ddce1f{fill:#ff6a11;}.b85b864c-891c-481f-b3e1-f851916bdb98{fill:#fff;}.a672974d-716e-48ff-a464-489c56832120,.f38b0bb9-7a65-4de5-97d2-b2002db1b20b{stroke:#645346;}.f38b0bb9-7a65-4de5-97d2-b2002db1b20b{fill:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f630b36d-1522-47b6-bd06-739978c3d603",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e31261bd-5151-4231-902b-7cf937ddce1f",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a0eac549-1715-4447-b635-0020002fa102",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b85b864c-891c-481f-b3e1-f851916bdb98",
    d: "M51.2,69.1l-1.1,3.2H48.8l3.4-10.1h1.6l3.4,10.1H55.8l-1-3.2Zm3.3-1-1-2.9a12.1,12.1,0,0,1-.5-1.8h-.1a12.1,12.1,0,0,1-.5,1.8l-1,2.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b85b864c-891c-481f-b3e1-f851916bdb98",
    d: "M60,62.2V72.3H58.7V62.2Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a672974d-716e-48ff-a464-489c56832120",
    x: 37.2,
    y: 48.9,
    width: 4.6,
    height: 4.58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a672974d-716e-48ff-a464-489c56832120",
    x: 59,
    y: 27.8,
    width: 4.6,
    height: 4.58
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a672974d-716e-48ff-a464-489c56832120",
    d: "M39.5,48.9A18.7,18.7,0,0,1,58.2,30.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a672974d-716e-48ff-a464-489c56832120",
    points: "49.7 45 48.4 39.5 53.9 40.8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "f38b0bb9-7a65-4de5-97d2-b2002db1b20b",
    x: 42.7,
    y: 33.8,
    width: 4.6,
    height: 4.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.5979b3ef4382ed1841bff1241c0118f0.svg";
export { ForwardRef as ReactComponent };